import { Link } from "@tanstack/react-router";
import { BadgeCheck, ArrowUpRight } from "lucide-react";
import { proofForSubject } from "@/content/proof";

/**
 * Renders a link to the provenance record backing the current page —
 * who did the work, how it was measured, and what evidence is public.
 * Returns null when the page has no proof record.
 */
export function ProofLink({ subjectPath }: { subjectPath: string }) {
  const proof = proofForSubject(subjectPath);
  if (!proof) return null;
  return (
    <aside className="mt-12 rounded-2xl border border-primary/30 bg-primary/5 p-6">
      <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-primary">
        <BadgeCheck size={14} /> Sources &amp; evidence status
      </div>
      <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
        This record explains the editorial corrections, available sources and evidence limitations.
        Practical guidance and project materials are not presented as verified performance results.
      </p>
      <Link
        to="/proof/$slug"
        params={{ slug: proof.slug }}
        className="mt-4 inline-flex min-h-11 items-center gap-1.5 text-sm font-semibold text-primary hover:underline"
      >
        See the proof record for {proof.entityName} <ArrowUpRight size={14} />
      </Link>
    </aside>
  );
}
